/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    InvokeCommand,
    InvokeCommandOutput,
    LambdaClient,
} from "@aws-sdk/client-lambda";
import { fetchAuthSession } from "aws-amplify/auth";

export default async function callLambda(
    functionName: string,
    bodyObject: any,
): Promise<InvokeCommandOutput | undefined> {
    try {
        const { credentials } = await fetchAuthSession();

        if (!credentials) {
            throw new Error("AWS credentials not available");
        }

        const lambda = new LambdaClient({
            region: process.env.REACT_APP_AWS_REGION,
            credentials,
        });

        const command = new InvokeCommand({
            FunctionName: functionName,
            Payload: JSON.stringify(bodyObject),
            InvocationType: "Event",
        });

        const response = lambda.send(command);

        return response;
    } catch (error: any) {
        if (process.env.BUILD_ENV !== "production") {
            // eslint-disable-next-line no-console
            console.warn("Error calling Lambda function:", error.message);
        }
        return undefined;
    }
}
